export default {
    path: "/administradores",
    name: "Admins",
    component: () => import("@/presentation/views/Admins/Admins.vue"),
    redirect: { name: "AdminsList" },
    meta: { requiresAuth: true },
    list: {
        path: "lista",
        name: "AdminsList",
        component: () =>
            import("@/presentation/views/Admins/AdminsList/AdminsList.vue"),
    },
    detail: {
        path: "detalhes/:id",
        name: "AdminDetail",
        component: () =>
            import("@/presentation/views/Admins/AdminDetail/AdminDetail.vue"),
    },
    add: {
        path: "adicionar",
        name: "AddAdmin",
        component: () =>
            import("@/presentation/views/Admins/AddAdmin/AddAdmin.vue"),
    },
} as const 